<div class="mydocma-mm-fields-delay-dropdown-tile">
  <div class="delay-image" *ngIf="imageUrl">
    <img [src]="imageUrl" alt="Delay status" />
  </div>
  <span class="delay-text">{{ item.text }}</span>
</div>